import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import { removeArrayItem } from '../../utils/arrayModify';

export const consts = createReqConsts('invitations', 'familyCircle', [
  'REMOVE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'family_member_invitations',
  type: 'get',
});

const requestReducer = createReqReducer(consts);

const removeItem = (state, { id }) => {
  const list = removeArrayItem(get(state, 'list', []), 'id', id);

  return { ...state, list };
};

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.REMOVE:
      return removeItem(state, payload);

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/invitations/familyMember.js